import { render, staticRenderFns } from "./SessionApiList.vue?vue&type=template&id=822c06c2&"
import script from "./SessionApiList.vue?vue&type=script&lang=js&"
export * from "./SessionApiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports